var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { FormControl, FormHelperText } from '@mui/material';
import React from 'react';
import Button from './BaseButton';
var FileField = function (_a) {
    var label = _a.label, name = _a.name, accept = _a.accept, _b = _a.multiple, multiple = _b === void 0 ? false : _b, _c = _a.error, error = _c === void 0 ? false : _c, _d = _a.helperText, helperText = _d === void 0 ? '' : _d, _e = _a.onChange, onChange = _e === void 0 ? function () {
        return;
    } : _e;
    var inputRef = React.createRef();
    var handleClick = React.useCallback(function () {
        var _a;
        (_a = inputRef.current) === null || _a === void 0 ? void 0 : _a.click();
    }, [inputRef]);
    return (React.createElement(FormControl, { error: error },
        React.createElement("input", { ref: inputRef, type: "file", name: name, accept: accept, onChange: onChange, hidden: true, multiple: multiple }),
        React.createElement(Button, { onClick: handleClick }, label),
        helperText && React.createElement(FormHelperText, null, helperText)));
};
export default FileField;
export var FormikFileField = function (_a) {
    var onChange = _a.onChange, formik = _a.formik, _b = _a.multiple, multiple = _b === void 0 ? false : _b, fileFieldProps = __rest(_a, ["onChange", "formik", "multiple"]);
    var nameAsKey = fileFieldProps.name;
    var handleChange = React.useCallback(function (event) {
        var file = event.target.files[0];
        if (!file)
            return;
        formik.setFieldValue(nameAsKey, file);
        if (onChange)
            onChange(event);
    }, [nameAsKey, formik, onChange]);
    var handleMultipleChange = React.useCallback(function (event) {
        var files = event.target.files;
        if (!files)
            return;
        formik.setFieldValue(nameAsKey, Array.from(files));
        if (onChange)
            onChange(event);
    }, [nameAsKey, formik, onChange]);
    return (React.createElement(FileField, __assign({ onChange: multiple ? handleMultipleChange : handleChange, error: Boolean(formik.errors[nameAsKey]), helperText: formik.errors[nameAsKey], multiple: multiple }, fileFieldProps)));
};
